import { z } from 'zod'

export const baseSchema = z.object({
  type: z.string().describe('组件类型'),
  storeId: z
    .string()
    .optional()
    .describe(
      '存储 ID。用于存储表单编辑、Service 组件(目前未支持) 发起 HTTP 请求产生的值。组件间交互时用到，数据会以此 ID 作为 key 存储到 Map 中。',
    ),
  storeIdRef: z
    .string()
    .optional()
    .describe('关联组件的 ID，会根据此 ID 去 store 中查找数据，关联的数据会可以被组件访问。'),
})

export type BaseSchema = z.infer<typeof baseSchema>
